import { IMG } from "../content";
import { Reveal } from "./Reveal";

const PHOTOS = [
  { src: IMG.reflection, alt: "A group of athletes sitting together on the grass outdoors", caption: "Reflection + Community", id: "reflection" },
  { src: IMG.joy, alt: "Two athletes laughing together in the gym", caption: "Joy + Belonging", id: "joy" },
  { src: IMG.brandTees, alt: "Two athletes wearing white Mindful Athlete t-shirts", caption: "Brand Identity", id: "brand" },
  { src: IMG.realCommunity, alt: "The full Mindful Athlete community group standing together", caption: "Real Community", id: "community" },
];

const Experience = () => (
  <section className="experience section-pad" data-testid="experience-section">
    <Reveal className="section-head-center">
      <p className="eyebrow" data-testid="experience-eyebrow">In community</p>
      <h2 className="section-heading">The Mindful Athlete Experience</h2>
      <p className="section-sub">
        More than training. Mindful Athlete brings athletes together through coaching, workshops and experiences
        focused on performance, personal development, recovery and connection.
      </p>
    </Reveal>
    <div className="experience-grid">
      {PHOTOS.map((photo, i) => (
        <Reveal key={photo.id} delay={i * 0.1}>
          <figure className="experience-item" data-testid={`experience-${photo.id}`}>
            <div className="experience-frame">
              <img src={photo.src} alt={photo.alt} loading="lazy" />
            </div>
            <figcaption>{photo.caption}</figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </section>
);

export default Experience;
